import{post } from '@/utils/request';
import{overseasserver,erpserver} from '@/utils/baseUrl';

//品种列表
export async function productlist(params) {
    return post(overseasserver+'/product/list', params, true)
}
//贸易
export async function tradeTypeList(params) {
    return post(overseasserver+'/currency/tradeTypeList', params, true)
}
//贸易
export async function tranType(params) {
    return post(overseasserver+'/currency/tranType', params, true)
}
//币种
export async function bzList(params) {
    return post(overseasserver+'/currency/bzList', params, true)
}
//付款
export async function payType(params) {
    return post(overseasserver+'/currency/payType', params, true)
}
//返回港口[有公共接口]
export async function getPortList(params) {
    return post(erpserver+'/currency/getPortList', params, true)
}
//仓库列表
export async function warehouselist(params) {
    return post(overseasserver+'/warehouse/list', params, true)
}
//客商列表查询
export async function list(params) {
    return post(overseasserver+'/kh/list', params, true)
}
//保存成本预估
export async function saveCostEstimation(params) {
    return post(overseasserver+'/export/saveCostEstimation', params, true)
}
//成本预估列表
export async function costEstimationList(params) {
    return post(overseasserver+'/export/costEstimationList', params, true)
}
//公司列表
export async function companylist(params) {
    return post(overseasserver+'/company/list', params, true)
}
//确认到港
export async function inventorysave(params) {
    return post(overseasserver+'/inventory/save', params, true)
}


